import { Location } from "./types";

function manhattanDistance(a: Location, b: Location) {
  return Math.abs(a.row - b.row) + Math.abs(a.col - b.col);
}

export default manhattanDistance;
